export const initialFranchiseManagementConfig = () => ({
    data: [],
    origins: [],
})

export const updateFranchiseManagementConfig = (currentState, action) => {

    return {
        ...currentState,
        franchiseManagementConfig: {
            ...currentState.franchiseManagementConfig,
            ...action.franchiseManagementConfig,
        }
    }
}

export const initialFranchiseManagementConfigDialog = () => ({
    open: false,
    rule: {
        nome: '',
        ativo: true,
        franquias: [],
        baseFaturamento: 'FATURAMENTO_TOTAL_EMPRESA',
        origensIsentas: [],
        tipoRoyalty: 'PERCENTUAL_FIXO',
        valorRoyalty: 0,
        taxaMarketing: 0,
        taxaAdministrativa: 0,
        taxaAdministrativaTipo: 'PERCENTUAL',
        frequencia: 'MENSAL',
        diaVencimento: 10,
    }
});

export const updateFranchiseManagementConfigDialog = (currentState, action) => {

    return {
        ...currentState,
        franchiseManagementConfigDialog: {
            ...currentState.franchiseManagementConfigDialog,
            ...action.franchiseManagementConfigDialog,
        },
    };
};